import { Historical, HistoricalResponse } from "@customTypes/responses/lawsuit";
import React from "react";
import { MovementHistoricalItem } from "../MovementHistoricalItem";
import { NormalText } from "@components/styles/dataDisplay";
import HistoricalSkeleton from "@pages/skeletons/HistoricalSkeleton";
import { InfiniteData } from "react-query";

type HistoricalStateProps = {
  data?: InfiniteData<HistoricalResponse>;
  isSuccess: boolean;
  isLoading: boolean;
};

const HistoricalsStateManagement: React.FC<HistoricalStateProps> = ({
  data,
  isSuccess,
  isLoading
}) => {
  if (isLoading) return <HistoricalSkeleton />;

  const historicalCurrentCount = data.pages.reduce((acc, page) => {
    return acc + page.historicals.length;
  }, 0);

  return (
    <>
      {historicalCurrentCount ? (
        isSuccess &&
          data &&
          data.pages.map((historicalPage, pageIndex) => {
            const { historicals } = historicalPage;
            const hasHistoricals = historicals.length > 0;
            return (
              <React.Fragment key={pageIndex}>
                {hasHistoricals && (
                  <>
                    {historicals.map((historical: Historical) => {
                      return <MovementHistoricalItem historical={historical} key={historical.id} />
                    })}
                  </>
                )}
              </React.Fragment>
            );
          })
      ) : (
        <NormalText noMargin>Esta etapa ainda não possui andamentos. </NormalText>
      )}
    </>
  );
};

export default HistoricalsStateManagement;
